import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { MissingHcpIcon } from '@/assets/icons/MissingHcpIcon';
import { EntityType } from '@/core/graphql/generated/types';
import {
	useIsDcrModalLoading,
	useOpenDcrModal
} from '@/core/store/dcrModal/dcrModalSelectors';
import { mergeSx } from '@/utils/mergeSx';

import { dcrSearchCtaStyles as sx } from './DcrSearchCta.styles';

type Props = {
	entityType: EntityType;
	customSx?: {
		header?: SxProps<Theme>;
	};
};

export const DcrSearchCta = ({ entityType, customSx }: Props) => {
	const { t } = useTranslation();
	const openDcrModal = useOpenDcrModal();
	const isLoading = useIsDcrModalLoading(entityType);

	return (
		<Box sx={sx.root}>
			<MissingHcpIcon sx={sx.icon} />

			<Box sx={sx.body}>
				<Typography sx={mergeSx(sx.header, customSx?.header)}>
					{entityType === EntityType.Hcp
						? t('Missing a person?')
						: t('Missing an organization?')}
				</Typography>
				<Typography sx={sx.caption}>
					{entityType === EntityType.Hcp
						? t(
								'Tell us who you’re looking for, and we’ll try to add them to our 20m+ records.'
							)
						: t(
								'Tell us what you’re looking for, and we’ll try to add it to our 6m+ records.'
							)}
				</Typography>
				<Button
					sx={sx.button}
					variant='outlined'
					onClick={() => openDcrModal(entityType)}
					size='small'
					loading={isLoading}
					loadingPosition='start'
				>
					{entityType === EntityType.Hcp
						? t('REQUEST NEW HCP')
						: t('REQUEST NEW HCO')}
				</Button>
			</Box>
		</Box>
	);
};
